module.exports = __webpack_public_path__ + "img/会员.5b5e6f58.png";